export default __webpack_public_path__ + "static/media/lines2Squiggle.ab4abecd.png";